import { Field, Checkbox, TextOutput, NumericInput, RadioGroup } from 'Components/Core';
import { FieldSet } from 'Components/Layout';
import { useSelector } from 'react-redux';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { pipe } from 'rxjs';
import { isNil } from 'ramda';
import { ICoreFieldProps } from './types';
import { FormatTypes } from 'Lib/Format';

let ContainsDissolvedSalt: React.FC<ICoreFieldProps> = ({
  createWorksheetSelector,
  editable,
  visible: isVisible,
  appendNamePrefix,
}) => {
  const containsDissolvedSalt = useSelector(createWorksheetSelector!(`${appendNamePrefix}.ContainsDissolvedSalt`));
  const saltMeasurement = useSelector(createWorksheetSelector!(`${appendNamePrefix}.SaltContentMeasuredIn`));

  const saltContentPptHasValue = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.SaltContentPpt`), (s) => !isNil(s))
  );
  const saltContentGlHasValue = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.SaltContentGl`), (s) => !isNil(s))
  );

  const fluidDensityHasValue = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.FluidDensity`), (s) => !isNil(s))
  );

  const saltContentOptions = [
    { label: 'Parts per thousand (ppt)', value: 'ppt' },
    { label: 'Volume (grams per litre)', value: 'g/L' },
  ];

  if (!isVisible) return null;

  return (
    <NamePrefixModifier appendNamePrefix={appendNamePrefix}>
      {editable ? (
        <FieldSet>
          <Field input={<Checkbox />} name="ContainsDissolvedSalt" />
          <FieldSet visible={containsDissolvedSalt}>
            <Field
              input={<RadioGroup />}
              name="SaltContentMeasuredIn"
              options={saltContentOptions}
              confirm={() => saltContentPptHasValue || saltContentGlHasValue || fluidDensityHasValue}
              confirmTitle="Switching Salt Content Measured in"
              confirmText={
                (saltContentPptHasValue || saltContentGlHasValue) && fluidDensityHasValue
                  ? 'Salt content and fluid density will be cleared.'
                  : saltContentPptHasValue || saltContentGlHasValue
                  ? 'Salt content will be cleared.'
                  : 'Fluid density will be cleared.'
              }
              confirmButtonText="Confirm"
            />
            <Field
              visible={saltMeasurement === saltContentOptions[0].value}
              input={<NumericInput />}
              name="SaltContentPpt"
            ></Field>
            <Field
              visible={saltMeasurement === saltContentOptions[1].value}
              input={<NumericInput />}
              name="SaltContentGl"
            ></Field>
            <Field
              visible={saltMeasurement === saltContentOptions[1].value}
              input={<NumericInput />}
              name="FluidDensity"
            ></Field>
          </FieldSet>
        </FieldSet>
      ) : (
        <FieldSet>
          <Field input={<TextOutput />} name="ContainsDissolvedSalt" format={{ type: FormatTypes.YesNo }} />
          <Field
            visible={containsDissolvedSalt && saltMeasurement === saltContentOptions[0].value}
            input={<TextOutput />}
            name="SaltContentPpt"
          />
          <Field
            visible={containsDissolvedSalt && saltMeasurement === saltContentOptions[1].value}
            input={<TextOutput />}
            name="SaltContentGl"
          />
          <Field
            visible={containsDissolvedSalt && saltMeasurement === saltContentOptions[1].value}
            input={<TextOutput />}
            name="FluidDensity"
          />
        </FieldSet>
      )}
    </NamePrefixModifier>
  );
};

ContainsDissolvedSalt = withInjectedProps(ContainsDissolvedSalt);

export { ContainsDissolvedSalt };
